import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { API_DEVICE_TYPE_URL } from '../../core.global';
import { BasicService } from '../../_base/services/basic.service';

@Injectable()
export class DeviceTypeService extends BasicService{
    baseUrl:string = '';
    
    constructor(protected http: HttpClient){
        super(http);
        this.baseUrl = API_DEVICE_TYPE_URL;
    }
}